// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"bb76dd61","315":"9673f71f","342":"25503ebf","437":"f203fdb9","544":"70b1e45c","558":"1fe74caf","573":"f8252f0a","586":"97d74cce","631":"ef88eeac","695":"9bae84e6","861":"66d74643"}[chunkId] + ".chunk.js";
};